(function () {
  'use strict';

  var PORTUGAL_CATEGORIES = [
    { value: 'walking-tours', label: 'Walking Tours' },
    { value: 'day-trips', label: 'Day Trips' },
    { value: 'boat-tours', label: 'Boat Tours' },
    { value: 'food-wine', label: 'Food & Wine' },
    { value: 'culture-night', label: 'Culture & Night' },
    { value: 'multi-day-tours', label: 'Multi-Day Tours' },
    { value: 'wellness-spa-experiences', label: 'Wellness & Spa' },
    { value: 'transfers', label: 'Transfers' },
    { value: 'vip-services', label: 'VIP Services' }
  ];

  var ITALY_CATEGORIES = [
    { value: 'day-trips-italy', label: 'Day Trips' }
  ];

  var CAPACITY = {
    'Fátima, Nazaré & Óbidos Day Trip': 20,
    'Walking Tour Lisbon + S. Jorge Castle Tickets': 20,
    'Sintra & Cascais: Day Trip with Pena Palace and Regaleira Tickets': 20,
    'Fátima (4-hour Half Day Tour)': 20,
    'Walking Tour Small Group Belém + Jerónimos Monastery Tickets (optional Boat Tour)': 7,
    "Small Group Food Tour: Lisbon's Flavors & Traditions": 20,
    'Jerónimos Monastery Guided Tour with Entrance Ticket Included': 20,
    'Lisbon: Vegan Food and Culture Walking Tour with Tastings': 20,
    'Sintra: Quinta da Regaleira Guided Tour with Tickets': 20,
    'Sintra: Pena Palace Guided Tour with Tickets': 20,
    'Sintra: Monserrate Palace Guided Tour with Tickets': 20,
    'Tagus River Sailboat Cruise (2-hour) with Welcome Drinks': 18,
    'Spiritual Luxury Tour: Fátima, Braga & Santiago de Compostela (5 Days)': 30,
    'VIP Hotel Transfer: Luxury Door-to-Door Service (Lisbon)': 32,
    'Timeless Évora: A Private Wine & Heritage Escape': 8,
    'Porto Wine Tour: Premium Cellars with Varied Tastings': 20,
    'Porto Signature Experience: Walking Tour with Wine Cellar Visit': 20,
    'Lisbon <> Porto Transfer (with optional stops)': 8,
    'Belém Tower: Guided Tour (Tickets Included)': 20,
    'Exclusive Authentic Douro Valley 4x4 Experience': 12,
    'Knights Templar of Tomar: Convent of Christ & Medieval Feast at Taverna Antiqua': 20,
    'Full Sintra Experience: Four Palaces, Moorish Castle & Transfer': 20,
    'Braga & Guimarães: The Historic Minho Day Tour': 20,
    'Gerês National Park: Nature, Wine & Traditions': 20,
    'Therapeutic Oriental Massage by Myo': 8,
    "Unique Journeys' Clients (Belém)": 25,
    'The Soul of Viana do Castelo: Santa Luzia, Traditional Culture & Maritime Legends': 10
  };

  function parseCapacity(value) {
    var nums = String(value || '').match(/\d+/g);
    if (!nums || !nums.length) return 0;
    return Math.max.apply(null, nums.map(function (n) { return parseInt(n, 10) || 0; }));
  }

  function cardCapacity(card, title) {
    var fromCard = parseCapacity(card && card.getAttribute('data-pmy-capacity'));
    if (fromCard) return fromCard;
    return CAPACITY[title] || 0;
  }

  function destination() {
    try {
      var params = new URLSearchParams(window.location.search);
      var fromUrl = params.get('pmy_destination');
      if (fromUrl === 'italy' || fromUrl === 'portugal') return fromUrl;
      if (/\/collections\/day-trips-italy(?:\/|$)/i.test(window.location.pathname || '')) return 'italy';
      var htmlDest = document.documentElement.getAttribute('data-pmy-destination');
      if (htmlDest === 'italy' || htmlDest === 'portugal') return htmlDest;
      var saved = localStorage.getItem('pmy_destination') || localStorage.getItem('pmy_home_destination') || localStorage.getItem('pmy_home_country') || localStorage.getItem('pmy_daytrip_destination');
      return saved === 'italy' ? 'italy' : 'portugal';
    } catch (e) {
      return /\/collections\/day-trips-italy(?:\/|$)/i.test(window.location.pathname || '') ? 'italy' : 'portugal';
    }
  }

  function saveDestination(dest) {
    dest = dest === 'italy' ? 'italy' : 'portugal';
    document.documentElement.setAttribute('data-pmy-destination', dest);
    try {
      localStorage.setItem('pmy_destination', dest);
      localStorage.setItem('pmy_home_destination', dest);
      localStorage.setItem('pmy_home_country', dest);
      localStorage.setItem('pmy_daytrip_destination', dest);
    } catch (e) {}
    return dest;
  }

  function syncCountryChips(dest) {
    dest = dest === 'italy' ? 'italy' : 'portugal';
    document.querySelectorAll('[id^="chips-section-"] .chip-item[data-pmy-destination]').forEach(function (chip) {
      var chipDest = chip.getAttribute('data-pmy-destination') || 'portugal';
      chip.hidden = chipDest !== dest;
    });
  }

  function findHomeInput(prefix) {
    return document.querySelector('input[id^="' + prefix + '"]');
  }

  function getSelectScope(input) {
    if (!input) return null;
    return input.closest('.pmy-fp-custom-select') || input.parentElement || null;
  }

  function getSelectLabel(scope) {
    if (!scope) return null;
    var trigger = scope.querySelector('.pmy-fp-select-trigger');
    return trigger ? trigger.querySelector('span') : null;
  }

  function resetSelectLabel(scope) {
    var label = getSelectLabel(scope);
    if (!label) return;
    if (!scope.dataset.pmyCategoryPlaceholder) {
      scope.dataset.pmyCategoryPlaceholder = label.textContent.trim() || 'Choose a category...';
    }
    label.textContent = scope.dataset.pmyCategoryPlaceholder;
    label.classList.add('is-placeholder');
  }

  function chooseSelectLabel(scope, text) {
    var label = getSelectLabel(scope);
    if (!label) return;
    label.textContent = text;
    label.classList.remove('is-placeholder');
  }

  function rebuildCategorySelect(dest) {
    var input = findHomeInput('pmy-fp-cat-');
    if (!input) return;

    var scope = getSelectScope(input);
    if (!scope) return;

    var optionsBox = scope.querySelector('.pmy-fp-select-options');
    if (!optionsBox) return;

    if (!scope.dataset.pmyCategoryPlaceholder) {
      var currentLabel = getSelectLabel(scope);
      scope.dataset.pmyCategoryPlaceholder = currentLabel && currentLabel.textContent.trim()
        ? currentLabel.textContent.trim()
        : 'Choose a category...';
    }

    var categories = dest === 'italy' ? ITALY_CATEGORIES : PORTUGAL_CATEGORIES;
    input.value = '';
    optionsBox.innerHTML = '';
    scope.classList.remove('open');

    categories.forEach(function (cat) {
      var option = document.createElement('div');
      option.className = 'pmy-fp-select-option';
      option.setAttribute('data-value', cat.value);
      option.textContent = cat.label;
      option.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        input.value = cat.value;
        chooseSelectLabel(scope, cat.label);
        scope.classList.remove('open');
        optionsBox.querySelectorAll('.pmy-fp-select-option').forEach(function (node) {
          node.classList.toggle('active', node === option);
        });
        var bar = scope.closest('.pmy-fp-search-bar');
        if (bar) bar.classList.remove('dropdown-active');
      });
      optionsBox.appendChild(option);
    });

    resetSelectLabel(scope);
  }

  function homeSearchValues() {
    var dateInput = findHomeInput('pmy-fp-date-');
    var peopleInput = findHomeInput('pmy-fp-people-');
    var categoryInput = findHomeInput('pmy-fp-cat-');
    return {
      date: dateInput ? dateInput.value : '',
      people: peopleInput ? parseInt(peopleInput.value || '0', 10) : 0,
      category: categoryInput ? categoryInput.value : ''
    };
  }

  function queryString(values, dest) {
    var params = new URLSearchParams();
    if (values.date) params.set('date', values.date);
    if (values.people) params.set('people', String(values.people));
    params.set('pmy_destination', dest);
    return params.toString();
  }

  function showItalyHomeResult(values) {
    window.location.href = '/collections/day-trips-italy?' + queryString(values, 'italy');
  }

  function installHomeSearch() {
    if (!findHomeInput('pmy-fp-cat-')) return;

    rebuildCategorySelect(destination());

    window.addEventListener('pmy:destination-change', function (event) {
      var dest = event && event.detail && event.detail.destination === 'italy' ? 'italy' : 'portugal';
      rebuildCategorySelect(dest);
    });

    window.pmyFPSearch = function () {
      var values = homeSearchValues();
      var dest = destination();

      if (dest === 'italy') {
        if (values.category && values.category !== 'day-trips-italy') return;
        showItalyHomeResult(values);
        return;
      }

      var target = values.category ? '/collections/' + values.category : '/collections/all';
      window.location.href = target + '?' + queryString(values, 'portugal');
    };
  }

  function parseTourData() {
    var map = {};
    document.querySelectorAll('script[type="application/json"][id^="tour-data-"]').forEach(function (node) {
      try {
        var data = JSON.parse(node.textContent || '{}');
        if (data && data.title) map[data.title] = data;
      } catch (e) {}
    });
    return map;
  }

  function dateAllowed(data, dateString) {
    if (!dateString || !data) return true;
    var date = new Date(dateString + 'T00:00:00');
    if (isNaN(date.getTime())) return true;

    var blockedDays = String(data.blocked_days || '')
      .split(',')
      .map(function (v) { return parseInt(v.trim(), 10); })
      .filter(function (v) { return !isNaN(v); });
    if (blockedDays.indexOf(date.getDay()) !== -1) return false;

    var blockedDates = String(data.blocked_dates || '')
      .split(',')
      .map(function (v) { return v.trim(); })
      .filter(Boolean);
    return blockedDates.indexOf(dateString) === -1;
  }

  function addCollectionFilterStyle() {
    if (document.getElementById('pmy-search-filter-style')) return;
    var style = document.createElement('style');
    style.id = 'pmy-search-filter-style';
    style.textContent = '.pmy-search-filtered-out{display:none!important}.pmy-search-no-results{grid-column:1/-1;text-align:center;padding:42px 20px;font-weight:700;opacity:.75}';
    document.head.appendChild(style);
  }

  function applyCollectionFilters() {
    var grid = document.querySelector('.pmy-cpg-grid');
    if (!grid) return;
    addCollectionFilterStyle();

    var params = new URLSearchParams(window.location.search);
    var people = parseInt(params.get('people') || '0', 10);
    var date = params.get('date') || '';
    var dest = destination();
    var dataMap = parseTourData();
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.pmy-cpg-card'));
    var candidates = [];

    cards.forEach(function (card) {
      card.classList.remove('pmy-search-filtered-out');
      var titleEl = card.querySelector('.pmy-cpg-title');
      var title = titleEl ? titleEl.textContent.trim() : '';
      var cardDest = card.getAttribute('data-pmy-destination') || (/\/collections\/day-trips-italy(?:\/|$)/i.test(window.location.pathname || '') ? 'italy' : 'portugal');
      var capacity = cardCapacity(card, title);
      var knownDestination = dest === 'italy'
        ? cardDest === 'italy'
        : cardDest !== 'italy' && Object.prototype.hasOwnProperty.call(CAPACITY, title);
      var availableDate = dateAllowed(dataMap[title], date);

      if (!knownDestination || !availableDate) {
        card.classList.add('pmy-search-filtered-out');
        return;
      }

      if (people) {
        if (!capacity || capacity < people) {
          card.classList.add('pmy-search-filtered-out');
          return;
        }
        candidates.push({ card: card, capacity: capacity });
      } else {
        candidates.push({ card: card, capacity: capacity || 999 });
      }
    });

    if (people && candidates.length) {
      var bestCapacity = Math.min.apply(null, candidates.map(function (item) { return item.capacity; }));
      candidates.forEach(function (item) {
        if (item.capacity !== bestCapacity) item.card.classList.add('pmy-search-filtered-out');
      });
    }

    var visible = cards.filter(function (card) { return !card.classList.contains('pmy-search-filtered-out'); });
    var count = document.querySelector('[id^="pmy-cpg-num-"]');
    if (count) count.textContent = String(visible.length);

    var oldEmpty = document.getElementById('pmy-search-no-results');
    if (oldEmpty) oldEmpty.remove();
    if (!visible.length) {
      var empty = document.createElement('div');
      empty.id = 'pmy-search-no-results';
      empty.className = 'pmy-search-no-results';
      empty.textContent = 'No experiences match the selected date and group size.';
      grid.appendChild(empty);
    }
  }

  function restoreDestinationFromUrl() {
    var dest = destination();
    saveDestination(dest);
    syncCountryChips(dest);
  }

  function colorWithAlpha(color, alpha) {
    var match = String(color || '').match(/rgba?\(([^)]+)\)/i);
    if (!match) return color;
    var parts = match[1].split(',').map(function (part) { return part.trim(); });
    if (parts.length < 3) return color;
    return 'rgba(' + parts[0] + ', ' + parts[1] + ', ' + parts[2] + ', ' + alpha + ')';
  }

  function installChipsGlassSync() {
    var chips = document.querySelector('[id^="chips-section-"]');
    if (!chips) return;

    function paint() {
      chips.style.removeProperty('background-color');
      chips.style.removeProperty('box-shadow');
      chips.style.removeProperty('border-bottom-color');
      chips.style.removeProperty('backdrop-filter');
      chips.style.removeProperty('-webkit-backdrop-filter');

      if (window.scrollY <= 10) return;

      /* Make sure theme-dependent CSS has been recalculated before sampling the base color. */
      void chips.offsetHeight;
      var baseColor = window.getComputedStyle(chips).backgroundColor;
      var glassColor = colorWithAlpha(baseColor, 0.85);
      chips.style.setProperty('background-color', glassColor, 'important');
      chips.style.setProperty('backdrop-filter', 'blur(12px)', 'important');
      chips.style.setProperty('-webkit-backdrop-filter', 'blur(12px)', 'important');
      chips.style.setProperty('border-bottom-color', 'transparent', 'important');
      chips.style.setProperty('box-shadow', '0 1px 0 ' + glassColor, 'important');
    }

    function paintAfterThemeChange() {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(paint);
      });
    }

    window.addEventListener('scroll', paint, { passive: true });
    var observer = new MutationObserver(function (mutations) {
      var shouldPaint = mutations.some(function (mutation) {
        return mutation.type === 'attributes' && mutation.attributeName === 'data-bs-theme';
      });
      if (shouldPaint) paintAfterThemeChange();
    });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-bs-theme'] });
    paint();
  }

  function init() {
    restoreDestinationFromUrl();
    installHomeSearch();
    applyCollectionFilters();
    installChipsGlassSync();

    function onDestinationChange(event) {
      var detail = event && event.detail || {};
      var next = detail.destination || detail.country || destination();
      next = saveDestination(next);
      syncCountryChips(next);
      rebuildCategorySelect(next);
      applyCollectionFilters();
    }

    window.addEventListener('pmy:destination-change', onDestinationChange);
    document.addEventListener('pmy:country-change', onDestinationChange);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
